import Landing from "./Landing";

/**
 * Ana Sayfa artık yalnızca vitrin (Landing). Günün maçları listesi buradan
 * kaldırıldı ve Tahmin sayfasına taşındı (GununMaclari). Ana sayfa istatistik
 * bulgularını + AI anlatımını öne çıkarır; maç akışı Tahmin'de.
 */
export default function Home({ onKesfet, onSorgula, onTahmin }) {
  return (
    <div className="home-page">
      <Landing onKesfet={onKesfet} onSorgula={onSorgula} onTahmin={onTahmin} />
    </div>
  );
}
